import { CallUsTemplate } from '@templates';
import { RoutesList } from '../../../../routes/Routes';
import { useNavigate } from 'react-router-dom';

export const CallUsPage = () => {
  const navigate = useNavigate();
  const subText =
    'This could be an emergency. You need to call us to report emergency issues. This helps us deal with them more quickly.';
  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.ISSUE_TYPE);
    },
  };


  const nextButton = {
    label: 'Back to homepage',
    isExternalLink: true,
    href: 'https://www.westminster.gov.uk/report-it',
    openInNewTab: true,
  };

  return (
    <CallUsTemplate subText={subText} buttonPrevious={buttonPrevious} buttonNext={nextButton} />
  );

};
